/**
 * Specifies the action taken as a result of the PartyActionType(2239) of the PartyActionRequest(35=DH) message.
 * tag: 2332
 * @readonly
 * @enum {number} (int)
 */
export enum PartyActionResponse {
  Accepted = 0,
  Completed = 1,
  Rejected = 2,
}
